import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["style", "size", "height", "width", "svgRef", "title"];
import React from 'react';
import PropTypes from 'prop-types';
import { genUID } from '@entrata/utils';
import { jsx as ___EmotionJSX } from "@emotion/core";
class ArrowDownSm extends React.Component {
  constructor(props) {
    super(props);
    this.titleId = genUID();
  }
  render() {
    const _this$props = this.props,
      {
        style = {},
        size = 16,
        height,
        width,
        svgRef,
        title
      } = _this$props,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return ___EmotionJSX("svg", _extends({
      viewBox: "0 0 32 32",
      height: height || size,
      width: width || size,
      ref: svgRef,
      "aria-labelledby": title ? this.titleId : undefined,
      style: _extends({
        pointerEvents: 'none',
        fill: 'currentColor'
      }, style)
    }, props), title ? ___EmotionJSX("title", {
      id: this.titleId
    }, title) : null, ___EmotionJSX("path", {
      d: "M16 21.6l-9.4-9.4 1.8-1.8L16 18l7.6-7.6 1.8 1.8-9.4 9.4z"
    }));
  }
}
ArrowDownSm.propTypes = {
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export { ArrowDownSm };